import { createAction, props } from '@ngrx/store';
import { SysAircraftMake } from 'app/core/models/sys-aircraft-make.model';
import { SysAircraftModel } from 'app/core/models/sys-aircraft-model.model';
import { Aircraft } from 'app/features/settings/models/aircraft.model';
import { SysApuModel } from 'app/features/settings/models/sys-apu-model.model';

// Aircraft
export const triggerAllAircrafts = createAction('[Aircraft] Load All Aircrafts');
export const triggerAircrafts = createAction('[Aircraft] Load Aircrafts');
export const aircraftsSuccess = createAction(
  '[Aircraft] Aircrafts Success',
  props<{ aircrafts: Aircraft[] }>()
);
export const aircraftsFailure = createAction(
  '[Aircraft] Aircrafts Failure',
  props<{ error: string }>()
);

// Aircraft Makes
export const triggerAircraftMakes = createAction('[Aircraft Makes] Load Aircraft Makes');
export const aircraftMakesSuccess = createAction(
  '[Aircraft Makes]  Aircraft Makes Success',
  props<{ aircraftMakes: SysAircraftMake[] }>()
);
export const aircraftMakesFailure = createAction(
  '[Aircraft Makes]  Aircraft Makes Failure',
  props<{ error: string }>()
);

// Aircraft Models
export const triggerAircraftModels = createAction('[Aircraft Models] Load Aircraft Models');
export const aircraftModelsSuccess = createAction(
  '[Aircraft Models]  Aircraft Models Success',
  props<{ aircraftModels: SysAircraftModel[] }>()
);
export const aircraftModelsFailure = createAction(
  '[Aircraft Models]  Aircraft Models Failure',
  props<{ error: string }>()
);

// APU Models
export const triggerApuModels = createAction('[APU Models] Load APU Models');
export const apuModelsSuccess = createAction(
  '[APU Models] APU Models Success',
  props<{ apuModels: SysApuModel[] }>()
);
export const apuModelsFailure = createAction(
  '[APU Models] APU Models Failure',
  props<{ error: string }>()
);
